//导入三个文件
import en from './en';
import cn from './cn';
import ar from './ar';

export default {
  en: en,
  cn: cn,
  ar: ar
}